import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import de from "./locales/de.json";
import { ensureLanguageLoaded } from "./lazyLocales";

// Perf (TES-1653): Nur die Default-/Fallback-Sprache `de` wird EAGER gebundlet. en/ja waren
// zusammen ~489KB im Initial-Bundle und blockierten FCP/Parse, obwohl die App immer in `de`
// startet (lng:"de"). Der On-demand-Loader `ensureLanguageLoaded` lebt im side-effect-freien
// Modul ./lazyLocales (so kann useLanguagePreference ihn importieren, ohne diesen i18n-Init in
// seinen Modulgraph zu ziehen). Bis der Chunk da ist, greift `fallbackLng:"de"`.
export { ensureLanguageLoaded } from "./lazyLocales";

i18n.use(initReactI18next).init({
  resources: { de: { translation: de } },
  lng: "de", // Default language
  fallbackLng: "de",
  interpolation: {
    escapeValue: false, // React already escapes by default
  },
  react: {
    useSuspense: false,
  },
});

// On-demand Nachladen beim Sprachwechsel (idempotent via hasResourceBundle-Guard).
i18n.on("languageChanged", (lng) => {
  void ensureLanguageLoaded(lng);
});

export default i18n;
